import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ISourceSiteViewModel } from '@services/cleanfill-api/cleanfill-api.generated';
import { StoreSourceSitesService } from '@services/cleanfill-core/store-source-sites/store-source-sites.service';

@Injectable()
export class SourceSiteResolver implements Resolve<ISourceSiteViewModel> {
  constructor(private sourceSiteStore: StoreSourceSitesService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ISourceSiteViewModel> {
    const sourceSiteUniqueId = route.params.sourceSiteUniqueId;
    return this.sourceSiteStore.loadSourceSite(sourceSiteUniqueId);
  }
}
